export default __webpack_public_path__ + "static/media/formulario.9773f3c3.svg";